interface PasswordErrorMessageProps {
  isCreate: boolean;
  password: string;
  confirmPassword: string;
}

export default function PasswordErrorMessage({
  isCreate,
  password,
  confirmPassword,
}: PasswordErrorMessageProps) {
  const isEmpty = isCreate && !password;
  const isMismatch = password !== confirmPassword;

  return (
    <p className="text-red-500">
      {isEmpty
        ? "* 사용자 등록을 위해 비밀번호를 입력해 주세요."
        : isMismatch
          ? "비밀번호가 일치하지 않습니다"
          : ""}
    </p>
  );
}
